<template>
  <component :is="tag" :class="classes">{{ content }}</component>
</template>

<script lang="ts">
export default defineComponent({
  name: "CustomHeader",
  props: {
    tag: {
      type: String,
      default: "h1"
    },
    defaultText: {
      type: String,
      default: ""
    },
    classes: {
      type: [String, Array],
      default: ""
    },
    queryName: {
      type: String,
      default: "maintitle"
    }
  },
  computed: {
    content() {
      const route = useRoute()
      const regex = /(<([^>]+)>)/gi
      const text = this.defaultText.replaceAll("&amp;", "&").replace(regex, "")
      return route.query[this.queryName] || text || "\xa0"
    }
  }
})
</script>
